module.exports = __webpack_public_path__ + "static/media/bg-urbes.f3fcb219.jpg";